module.exports = __webpack_public_path__ + "img/kin1.60b708fe.jpg";